import React from 'react';
import {ConfigTypeT} from '../../types/settings';
import {DepartmentsConfiguration} from './Departments';
import {PermissionsConfiguration} from './Permissions';
import {RolesConfiguration} from './Role';
import {TicketConfiguration} from './Ticket';

export type ConfigurationsProps = {
  configType: ConfigTypeT;
};

export const Configurations: React.FC<ConfigurationsProps> = ({configType}) => {
  if (configType === 'role') return <RolesConfiguration />;
  if (configType === 'department') return <DepartmentsConfiguration />;
  if (configType === 'ticket') return <TicketConfiguration />;
  if (configType === 'permission') return <PermissionsConfiguration />;
  return <></>;
};
